import { Card, DatePicker, Form, Input, Select, Spin } from 'antd';
import React from "react";
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";

class Create extends React.Component {

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }


  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form } = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form layout="vertical">

            {Object.keys(filters).map((item) => {
              if (item === 'requestPayload' || item === 'responsePayload' || item === 'source') {
                return <div style={{ marginBottom: '10px', border: '1px solid #e0e0e0', padding: '10px', borderRadius: '5px' }}>
                  <label>{sanitizeFieldName(item)}</label>
                  <pre>{JSON.stringify(data[item], null, 2)}</pre>
                </div>
              }
              return getFormFieldByType(filters, item, getFieldDecorator, data, { resource, title: 'VIEW' })

            })}
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
